import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../scss/downloadfinder_styles.scss';

import DfSearchModule from './scenes/df-search';
import DfResults from './scenes/df-results';
import DfBookmarks from './scenes/df-bookmarks';
import DfProduct from './scenes/df-product';

(async () => {
  const dfSearch = document.querySelector('#df-search');
  if (dfSearch) {
    createRoot(dfSearch).render(<DfSearchModule />);
  }

  const dfResults = document.querySelector('#df-search-results');
  if (dfResults) {
    createRoot(dfResults).render(<DfResults />);
  }

  const dfBookmarks = document.querySelector('#df-bookmark-list');
  if (dfBookmarks) {
    createRoot(dfBookmarks).render(<DfBookmarks />);
  }

  const activeDfProduct = document.querySelector('.tab.active #df-product-downloads');
  const dataAttributesDom = document.querySelector<HTMLElement>('[data-plugin="downloadfinder"]');
  // only init if active
  if (activeDfProduct && dataAttributesDom) {
    createRoot(activeDfProduct).render(<DfProduct dfProductDom={dataAttributesDom} />);
  } else if (dataAttributesDom) {
    const dfProduct = document.querySelector('#df-product-downloads');
    const dfProductTab = dfProduct?.parentNode;
    const observer = new MutationObserver(function (event) {
      if (
        event[0].attributeName === 'class' &&
        event[0].target instanceof HTMLElement &&
        event[0].target?.classList?.value.includes('active') &&
        dfProduct
      ) {
        createRoot(dfProduct).render(<DfProduct dfProductDom={dataAttributesDom} />);
        observer.disconnect();
      }
    });

    if (dfProductTab) {
      observer.observe(dfProductTab, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false,
      });
    }
  }
})();
